import { TrueBase, css, html } from "../TrueBase/TrueBase";

/**
 * @customelement true-card
 * @description
 * This is a basic card component.

 *
 */

export const baseCardStyling = css`
  :host {
    display: var(--card-display, flex);
    flex-direction: var(--card-flex-direction, column);
    border-radius: var(--card-border-radius, 0px);
    border: var(--card-border, 1px solid black);
    padding: var(--card-padding, 0);
    background: var(--card-background, white);
    box-shadow: var(--card-box-shadow, none);
    overflow: var(--card-overflow, hidden);
    height: var(--card-height, 100%);
    transition: all 0.3s ease;
  }

  :host(:hover) {
    border: var(--card-hover-border, 1px solid black);
    background: var(--card-hover-background, white);
    box-shadow: var(
      --card-hover-box-shadow,
      rgba(0, 0, 0, 0.03) 0px 0.9px 1.5px 0px,
      rgba(0, 0, 0, 0.08) 0px 3.1px 5.5px 0px,
      rgba(0, 0, 0, 0.12) 0px 14px 25px 0px
    );
  }

  ::slotted(*) {
    color: var(--card-color, var(--text-color, #000));
  }

  .card-titles {
    display: flex;
    flex-direction: var(--card-titles-flex-direction, column);
    align-items: var(--card-titles-align-items, unset);
  }

  ::slotted([slot="title"]) {
    color: var(--card-title-color, var(--color-primary, #000));
  }

  :host(:hover) ::slotted([slot="title"]) {
    color: var(--card-hover-title-color, var(--color-primary, #000000));
  }

  ::slotted([slot="subtitle"]) {
    color: var(--card-subtitle-color, var(--color-secondary, #2b2b2b));
    font-size: var(--card-subtitle-font-size, var(--small-font-size, 0.8rem));
    margin: var(--card-subtitle-margin, 0);
  }

  :host(:hover) ::slotted([slot="subtitle"]) {
    color: var(--card-hover-subtitle-color, #000);
  }

  .true-card__content {
    height: var(--card-body-height, 100%);
    padding: var(--card-body-padding, 2rem);
    background: var(--card-body-background, #fbfbfb);
    position: relative;
    transition: var(--transition, all 0.3s ease);
    flex: 1;
  }

  :host(:hover) .true-card-content {
    background: var(--card-hover-body-background, #fbfbfb);
  }

  .card-content-wrapper {
    height: var(--card-content-wrapper-height, 100%);
    display: var(--card-content-wrapper-display, flex);
    flex-direction: var(--card-content-flex-direction, column);
    justify-content: var(--card-content-flex-justify-content, flex-start);
    align-items: var(--card-content-flex-align-items, flex-start);
  }

  .true-card__header {
    position: relative;
    min-height: var(--card-header-height, 10rem);
    z-index: 1;
    width: var(--card-header-width, 100%);
    background: var(--card-header-background, transparent);
    padding: var(--card-header-padding, 0);
    border-bottom: var(--card-header-border-bottom, none);
  }

  .true-card__footer {
    padding: var(--card-footer-padding, 0);
    background: var(--card-footer-background, transparent);
    border-top: var(--card-footer-border-top, none);
  }

  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    .true-card__content {
      flex: 1 1 auto;
    }
  }
`;

export class TrueCard extends TrueBase {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  render() {
    return html`
      <div class="true-card__header">
        <slot id="cardImage" name="cardImage"></slot>
      </div>
      <div class="true-card__content tp-content-wrapper">
        <div class="card-content-wrapper">
          <div class="card-titles">
            <slot name="title"></slot>
            <slot name="subtitle"></slot>
          </div>
          <slot></slot>
        </div>
      </div>
      <div class="true-card__footer">
        <slot name="footer"></slot>
      </div>
    `;
  }

  firstUpdated() {
    const slot = this.shadowRoot.querySelector("#cardImage");
    const nodes = slot.assignedNodes();
    if (nodes.length === 0) {
      slot.parentElement.style.display = "none";
    }
  }

  static get styles() {
    return [super.styles, baseCardStyling];
  }
}

window.customElements.get("true-card") ||
  window.customElements.define("true-card", TrueCard);
